/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
  var registeredInModuleLoader = false;
  if (typeof define === 'function' && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === 'object') {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = window.Cookies = factory();
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
}(function () {
  function extend () {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[i];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function init (converter) {
    function api (key, value, attributes) {
      var result;
      if (typeof document === 'undefined') {
        return;
      }

      // Write

      if (arguments.length > 1) {
        attributes = extend({
          path: '/'
        }, api.defaults, attributes);

        if (typeof attributes.expires === 'number') {
          var expires = new Date();
          expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
          attributes.expires = expires;
        }

        // We're using "expires" because "max-age" is not supported by IE
        attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

        try {
          result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) { }

        if (!converter.write) {
          value = encodeURIComponent(String(value))
            .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
        } else {
          value = converter.write(value, key);
        }

        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);

        var stringifiedAttributes = '';

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += '; ' + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }
          stringifiedAttributes += '=' + attributes[attributeName];
        }
        return (document.cookie = key + '=' + value + stringifiedAttributes);
      }

      // Read

      if (!key) {
        result = {};
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var cookie = parts.slice(1).join('=');

        if (!this.json && cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          cookie = converter.read ?
            converter.read(cookie, name) : converter(cookie, name) ||
            cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) { }
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) { }
      }

      return result;
    }

    api.set = api;
    api.get = function (key) {
      return api.call(api, key);
    };
    api.getJSON = function () {
      return api.apply({
        json: true
      }, [].slice.call(arguments));
    };
    api.defaults = {};

    api.remove = function (key, attributes) {
      api(key, '', extend(attributes, {
        expires: -1
      }));
    };

    api.withConverter = init;

    return api;
  }

  return init(function () { });
}));

(function ($) {
  jQuery.extend({
    getQueryParameters: function (str) {
      return (str || document.location.search).replace(/(^\?)/, '').split('&').map(function (n) {
        return n = n.split('='), this[n[0]] = n[1], this;
      }.bind({}))[0];
    }
  });

  //Randomize function for slick carousel.
  $.fn.randomize = function (selector) {
    var $elems = selector ? $(this).find(selector) : $(this).children(),
      $parents = $elems.parent();

    $parents.each(function () {
      $(this).children(selector).sort(function () {
        return Math.round(Math.random()) - 0.5;
      }).detach().appendTo(this);
    });

    return this;
  };

  function toggleExpansion (e) {
    e.preventDefault();
    var $this = $(this);
    $this.closest('.staff-expansion').toggleClass('expanded');
  }

  $('body').on('click', '.expand', toggleExpansion);
  $('body').on('click', '.shrink', toggleExpansion);
  $('.slick-carousel').slick({
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    adaptiveHeight: true
  });
  /*$(".case-study-filters").on("change", "select", function () {
    var queryParams = $.getQueryParameters();
    var query = $(this).val();
    var name = $(this).attr("name");
    queryParams[name] = query;
    var baseUrl = document.location.search.split("?")[0];
    window.location.href = baseUrl + "?" + $.map(queryParams, function (val, key) {
      return key + "=" + val;
    }).join("&") + "#filters";
    return false;
  });*/

  var $videos = $('.videos');
  $videos.find('.video').first().addClass('active');
  // $videos.find(".video-title").first().addClass("active");
  $videos.on('click', '.video-title h3', function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    var $parent = $target.parent('.video-title');
    var id = $parent.data('video-id');
    $videos.find('.video').removeClass('active');
    $videos.find('.video-title').removeClass('active');
    $videos.find('.video[data-video-id="' + id + '"]').addClass('active');
    $parent.addClass('active');
  });

  // Add the 'Top Products' title to the vendor drop down
  $('#menu-item-34253 > .dropdown-menu').prepend('<li class="menu-title">Featured Vendors <a href="/all-vendors/" class="btn">View All Vendors</a><div class="clearfix"></div></li>');

  $('.listing-section .image-holder').matchHeight();
  $('#footer-banner .image').matchHeight();

  // Randomize the slides and then call slick
  $('.slick-carousel-header').randomize('.item');

  $('.slick-carousel-header').slick({
    fade: true,
    lazyLoad: 'ondemand',
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    cssEase: 'linear'
  });

  $('#partner-carousel').slick({
    infinite: true,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 10000,
    slidesToShow: 4,
    slidesToScroll: 4,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(document).ready(function () {
    var solution_id = 0;

    $('#subscribe-bar-close').on('click', function (e) {
      Cookies.set('subscribe-bar-hidden', true);
      $('#subscribe-bar').remove();
    });

    $('#header-banner').css('visibility', 'visible');

    $('#filterForm').submit(function () {
      $(this).find(':input').filter(function () { return !this.value; }).attr('disabled', 'disabled');
      return true;
    });

    $('#filterToggle').on('click', function (e) {
      e.preventDefault();
      $('#filter-wrapper').slideToggle();
    });

    if ($(window).width() < 1199) {
      $('.filters-wrapper .panel-title').addClass('collapsed');
      $('.filters-wrapper .panel-title a span').removeClass('glyphicon-minus').addClass('glyphicon-plus');
      $('.filters-wrapper .panel-collapse').removeClass('in');
    }

    $(window).on('resize', function () {
      var win = $(this); //this = window
      if (win.width() >= 992) { $('#filter-wrapper').show(); } else {$('#filter-wrapper').hide(); }
    });

    $('#filterForm #resetFilter').on('click', function (e) {
      e.preventDefault();
      $('#filter-wrapper .dropdown ul li').each(function () {
        $(this).show();
        $(this).parent().parent().find('button').removeData('selected_id');
      });
      $('#filter-wrapper .dropdown.solutions button').html('Solutions <span class="glyphicon glyphicon-menu-right"></span>');
      $('#filter-wrapper .dropdown.types button').html('Products <span class="glyphicon glyphicon-menu-right"></span>');
      $('#filter-wrapper .dropdown.vendor-types button').html('Manufacturers <span class="glyphicon glyphicon-menu-right"></span>');
      $('#filterForm input[type=hidden]').val('');
    });

    $('#filter-wrapper .dropdown ul li').on('click', function () {
      var selected = $(this).find('a').text();
      var value = $(this).data('slug');
      $(this).parent().parent().find('button').text(selected);
      $(this).parent().parent().find('button').data('selected_id', $(this).data('id'));
      $(this).parent().parent().find('input[type=hidden]').val(value);
    });

    $('#case-study-filters .dropdown ul li').on('click', function () {
      var selected = $(this).find('a').text();
      var value = $(this).data('slug');
      $(this).parent().parent().find('button span').text(selected);
      $(this).parent().parent().find('button i').removeClass('glyphicon-menu-down');
      $(this).parent().parent().find('button i').addClass('glyphicon-menu-right');
      $(this).parent().parent().find('button').data('selected_id', $(this).data('id'));
      $(this).parent().parent().find('input[type=hidden]').val(value);
    });

    function product_search_filter (callback) {
      var ret_array = [
        [],		// Solutions
        [],		// Product Types
        []		// Manufacturers
      ];

      // Populate solutions
      $('#filter-wrapper .dropdown.solutions ul li').each(function () {
        ret_array[0].push($(this).data('id'));
      });

      // Populate product types
      $('#filter-wrapper .dropdown.types ul li').each(function () {
        ret_array[1].push($(this).data('id'));
      });

      // Populate manufacturers
      $('#filter-wrapper .dropdown.vendor-types ul li').each(function () {
        ret_array[2].push($(this).data('id'));
      });

      //
      var selectedSolutions = $('#solutionDropdown').data('selected_id');
      var selectedSolutionsElement = $('.solutions .dropdown-menu li').filter(function () {
        return $(this).data('id') == selectedSolutions;
      });
      var selectedProductTypes = $('#typeDropdown').data('selected_id');
      var selectedProductTypesElement = $('.types .dropdown-menu li').filter(function () {
        return $(this).data('id') == selectedProductTypes;
      });
      var selectedManufacturers = $('#vendorDropdown').data('selected_id');
      var selectedManufacturersElement = $('.vendor-types .dropdown-menu li').filter(function () {
        return $(this).data('id') == selectedManufacturers;
      });

      // Filter solutions
      if (selectedProductTypes || selectedManufacturers) {
        if (selectedProductTypes) {
          $('#filter-wrapper .dropdown.solutions ul li').each(function () {
            if (!$(selectedProductTypesElement).data('solutions').toString().includes($(this).data('id'))) {
              if (ret_array[0].indexOf($(this).data('id')) != -1)
                ret_array[0].splice(ret_array[0].indexOf($(this).data('id')), 1);
            }
          });
        }

        if (selectedManufacturers) {
          $('#filter-wrapper .dropdown.solutions ul li').each(function () {
            if (!$(selectedManufacturersElement).data('solutions').toString().includes($(this).data('id'))) {
              if (ret_array[0].indexOf($(this).data('id')) != -1)
                ret_array[0].splice(ret_array[0].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      // Filter Product types
      if (selectedSolutions || selectedManufacturers) {
        if (selectedSolutions) {
          $('#filter-wrapper .dropdown.types ul li').each(function () {
            if (!$(selectedSolutionsElement).data('product-types').toString().includes($(this).data('id'))) {
              if (ret_array[1].indexOf($(this).data('id')) != -1)
                ret_array[1].splice(ret_array[1].indexOf($(this).data('id')), 1);
            }
          });
        }

        if (selectedManufacturers) {
          $('#filter-wrapper .dropdown.types ul li').each(function () {
            if (!$(selectedManufacturersElement).data('product-types').toString().includes($(this).data('id'))) {
              if (ret_array[1].indexOf($(this).data('id')) != -1)
                ret_array[1].splice(ret_array[1].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      // Filter Manufacturers
      if (selectedSolutions || selectedProductTypes) {
        if (selectedSolutions) {
          $('#filter-wrapper .dropdown.vendor-types ul li').each(function () {
            if (!$(selectedSolutionsElement).data('vendors').toString().includes($(this).data('id'))) {
              if (ret_array[2].indexOf($(this).data('id')) != -1)
                ret_array[2].splice(ret_array[2].indexOf($(this).data('id')), 1);
            }
          });
        }

        if (selectedProductTypes) {
          $('#filter-wrapper .dropdown.vendor-types ul li').each(function () {
            if (!$(selectedProductTypesElement).data('vendors').toString().includes($(this).data('id'))) {
              if (ret_array[2].indexOf($(this).data('id')) != -1)
                ret_array[2].splice(ret_array[2].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      if (callback)
        callback(ret_array);
      else {
        // Hide/Show Solutions
        $('#filter-wrapper .dropdown.solutions ul li').each(function () {
          $(this).show();
          if (ret_array[0].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });

        // Hide/Show Product Types
        $('#filter-wrapper .dropdown.types ul li').each(function () {
          $(this).show();
          if (ret_array[1].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });

        // Hide/Show Manufactorers
        $('#filter-wrapper .dropdown.vendor-types ul li').each(function () {
          $(this).show();
          if (ret_array[2].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });
      }

      return ret_array;
    }

    $('#filter-wrapper .dropdown.solutions ul li').on('click', function () {
      product_search_filter();
    });

    $('#filter-wrapper .dropdown.types ul li').on('click', function () {
      product_search_filter();
    });

    $('#filter-wrapper .dropdown.vendor-types ul li').on('click', function () {
      product_search_filter();
    });

    function case_studies_filter (callback) {
      var ret_array = [
        [], // Solution
        [],	// Vendor
        [],	// Product
        []	// Sector
      ];

      // Populate solutions
      $('#case-study-filters .dropdown.cs-solution ul li').each(function () {
        ret_array[0].push($(this).data('id'));
      });

      // Populate vendors
      $('#case-study-filters .dropdown.cs-vendor ul li').each(function () {
        ret_array[1].push($(this).data('id'));
      });

      // Populate products
      $('#case-study-filters .dropdown.cs-product ul li').each(function () {
        ret_array[2].push($(this).data('id'));
      });

      // Populate sectors
      $('#case-study-filters .dropdown.cs-sector ul li').each(function () {
        ret_array[3].push($(this).data('id'));
      });

      // Solution
      var selected_solution = $('#csSolutionDropdown').data('selected_id');
      var selected_solution_element = $('.cs-solution .dropdown-menu li').filter(function () {
        return $(this).data('id') == selected_solution;
      });

      // Vendor
      var selected_vendor = $('#csVendorDropdown').data('selected_id');
      var selected_vendor_element = $('.cs-vendor .dropdown-menu li').filter(function () {
        return $(this).data('id') == selected_vendor;
      });

      // Product
      var selected_product = $('#csProductDropdown').data('selected_id');
      var selected_product_element = $('.cs-product .dropdown-menu li').filter(function () {
        return $(this).data('id') == selected_product;
      });

      // Sector
      var selected_sector = $('#csSectorDropdown').data('selected_id');
      var selected_sector_element = $('.cs-sector .dropdown-menu li').filter(function () {
        return $(this).data('id') == selected_sector;
      });

      // Filter solutions
      if (selected_vendor || selected_product ||selected_sector ) {
        // Vendor
        if (selected_vendor) {
          $('#case-study-filters .dropdown.cs-solution ul li').each(function () {
            if (!$(selected_vendor_element).data('solution').toString().includes($(this).data('id'))) {
              if (ret_array[0].indexOf($(this).data('id')) != -1)
                ret_array[0].splice(ret_array[0].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Product
        if (selected_product) {
          $('#case-study-filters .dropdown.cs-solution ul li').each(function () {
            if (!$(selected_product_element).data('solution').toString().includes($(this).data('id'))) {
              if (ret_array[0].indexOf($(this).data('id')) != -1)
                ret_array[0].splice(ret_array[0].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Sector
        if (selected_sector) {
          $('#case-study-filters .dropdown.cs-solution ul li').each(function () {
            if (!$(selected_sector_element).data('solution').toString().includes($(this).data('id'))) {
              if (ret_array[0].indexOf($(this).data('id')) != -1)
                ret_array[0].splice(ret_array[0].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      // Filter Vendors
      if (selected_solution || selected_product ||selected_sector ) {
        // Solution
        if (selected_solution) {
          $('#case-study-filters .dropdown.vendor ul li').each(function () {
            if (!$(selected_solution_element).data('vendor').toString().includes($(this).data('id'))) {
              if (ret_array[1].indexOf($(this).data('id')) != -1)
                ret_array[1].splice(ret_array[1].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Product
        if (selected_product) {
          $('#case-study-filters .dropdown.cs-vendor ul li').each(function () {
            if (!$(selected_product_element).data('vendor').toString().includes($(this).data('id'))) {
              if (ret_array[1].indexOf($(this).data('id')) != -1)
                ret_array[1].splice(ret_array[1].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Sector
        if (selected_sector) {
          $('#case-study-filters .dropdown.cs-vendor ul li').each(function () {
            if (!$(selected_sector_element).data('vendor').toString().includes($(this).data('id'))) {
              if (ret_array[1].indexOf($(this).data('id')) != -1)
                ret_array[1].splice(ret_array[1].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      // Filter Products
      if (selected_vendor || selected_solution ||selected_sector ) {
        // Vendor
        if (selected_vendor) {
          $('#case-study-filters .dropdown.cs-product ul li').each(function () {
            if (!$(selected_vendor_element).data('product').toString().includes($(this).data('id'))) {
              if (ret_array[2].indexOf($(this).data('id')) != -1)
                ret_array[2].splice(ret_array[2].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Solution
        if (selected_solution) {
          $('#case-study-filters .dropdown.cs-product ul li').each(function () {
            if (!$(selected_solution_element).data('product').toString().includes($(this).data('id'))) {
              if (ret_array[2].indexOf($(this).data('id')) != -1)
                ret_array[2].splice(ret_array[2].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Sector
        if (selected_sector) {
          $('#case-study-filters .dropdown.cs-product ul li').each(function () {
            if (!$(selected_sector_element).data('product').toString().includes($(this).data('id'))) {
              if (ret_array[2].indexOf($(this).data('id')) != -1)
                ret_array[2].splice(ret_array[2].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      // Filter Sector
      if (selected_vendor || selected_product ||selected_solution ) {
        // Vendor
        if (selected_vendor) {
          $('#case-study-filters .dropdown.cs-sector ul li').each(function () {
            if (!$(selected_vendor_element).data('sector').toString().includes($(this).data('id'))) {
              if (ret_array[3].indexOf($(this).data('id')) != -1)
                ret_array[3].splice(ret_array[3].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Product
        if (selected_product) {
          $('#case-study-filters .dropdown.cs-sector ul li').each(function () {
            if (!$(selected_product_element).data('sector').toString().includes($(this).data('id'))) {
              if (ret_array[3].indexOf($(this).data('id')) != -1)
                ret_array[3].splice(ret_array[3].indexOf($(this).data('id')), 1);
            }
          });
        }

        // Sector
        if (selected_solution) {
          $('#case-study-filters .dropdown.cs-sector ul li').each(function () {
            if (!$(selected_solution_element).data('sector').toString().includes($(this).data('id'))) {
              if (ret_array[3].indexOf($(this).data('id')) != -1)
                ret_array[3].splice(ret_array[3].indexOf($(this).data('id')), 1);
            }
          });
        }
      }

      if (callback)
        callback(ret_array);
      else {
        // Hide/Show Solution
        $('#case-study-filters .dropdown.cs-solution ul li').each(function () {
          $(this).show();
          if (ret_array[0].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });

        // Hide/Show Vendor
        $('#case-study-filters .dropdown.cs-vendor ul li').each(function () {
          $(this).show();
          if (ret_array[1].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });

        // Hide/Show Product
        $('#case-study-filters .dropdown.cs-product ul li').each(function () {
          $(this).show();
          if (ret_array[2].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });

        // Hide/Show Sector
        $('#case-study-filters .dropdown.cs-sector ul li').each(function () {
          $(this).show();
          if (ret_array[3].indexOf($(this).data('id')) == -1) {
            $(this).hide();
          }
        });
      }

      return ret_array;
    }

    $('#case-study-filters .dropdown.cs-solution ul li').on('click', function () {
      case_studies_filter();
    });

    $('#case-study-filters .dropdown.cs-vendor ul li').on('click', function () {
      case_studies_filter();
    });

    $('#case-study-filters .dropdown.cs-product ul li').on('click', function () {
      case_studies_filter();
    });

    $('#case-study-filters .dropdown.cs-sector ul li').on('click', function () {
      case_studies_filter();
    });

    $('.selected-filters .selected-filter').on('click', function () {
      var selected = $(this).data('slug');
      var taxonomy = $('.panel-body').find('[data-slug=' + selected + ']').parents('.panel-group').find('.panel-title a').data('slug');
      var url = new Url();
      var params = url.query;
      var tax_params = params[taxonomy];
      var params_array = tax_params.split(',');
      var arrayCheck = $.inArray(selected, params_array);
      if (arrayCheck !== -1) {
        params_array.splice(params_array.indexOf(selected), 1);
        var values = params_array.join(',');
        params[taxonomy] = values;
        if (params[taxonomy] === '') delete params[taxonomy];
        window.location.href = url;
      }
      //delete params[taxonomy];
      //window.location.href = url;
    });

    $('.panel-group .filter-child').on('click', function () {
      var selected = $(this).data('slug');
      var taxonomy = $(this).parents('.panel-group').find('.panel-title a').data('slug');
      var url = new Url();
      var params = url.query;
      var tax_params = params[taxonomy];
      if (tax_params == null) tax_params = '';
      var params_array = tax_params.split(',');
      var arrayCheck = $.inArray(selected, params_array);

      if ($(this).hasClass('active') && arrayCheck !== -1) {
        params_array.splice(params_array.indexOf(selected), 1);
        var vd = params_array.join(',');
        tax_params = vd;
        if (tax_params === '') delete params[taxonomy];
        window.location.href = url;
      } else {
        var va = '';
        if (tax_params !== '') {
          params_array.push(selected);
          va = params_array.join(',');
        } else {
          va = selected;
        }
        params[taxonomy] = va;
        window.location.href = url;
      }
    });

    $('.reset-wrap .reset').on('click', function () {
      var url = new Url();
      url.clearQuery();
      window.location.href = url.toString();
    });

    $('.filters-wrapper .panel-group .panel-title a').on('click', function () {
      var toggle = $(this).find('.filter-toggle');
      if (toggle.hasClass('glyphicon-plus')) {
        toggle.removeClass('glyphicon-plus');
        toggle.addClass('glyphicon-minus');
      } else {
        toggle.removeClass('glyphicon-minus');
        toggle.addClass('glyphicon-plus');
      }
    });

    $('#filterForm .dropdown button').on('click', function () {
      var parent = $(this).parent();
      var toggle = $(this).find('span');
      if (parent.hasClass('open')) {
        toggle.removeClass('glyphicon-menu-down');
        toggle.addClass('glyphicon-menu-right');
      } else {
        toggle.removeClass('glyphicon-menu-right');
        toggle.addClass('glyphicon-menu-down');
      }
    });

    $('#case-study-filters .dropdown button').on('click', function () {
      var parent = $(this).parent();
      var toggle = $(this).find('i');
      if (parent.hasClass('open')) {
        toggle.removeClass('glyphicon-menu-down');
        toggle.addClass('glyphicon-menu-right');
      } else {
        toggle.removeClass('glyphicon-menu-right');
        toggle.addClass('glyphicon-menu-down');
      }
    });

    // * Vendor page - Letter filtering
    // Smooth scroll to correct header depending on letter
    $('.filter-link').each(function () {
      $(this).on('click', function (e) {
        e.preventDefault();

        // Get the data letter attribute and its header
        var letter = $(this).data('letter');
        var targetHeader = $('h1[data-letter=' + letter + ']');
        var offsetTop = 25;

        // Scroll to the right header
        $('html, body').animate({
          scrollTop: $(targetHeader).offset().top - offsetTop
        }, 500);
      });
    });
  });
})(jQuery); // Fully reference jQuery after this point.
